import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  CadPadTermsComponent, OrganizationTermsComponent,
  ParentTermsComponent, TermsComponent, UsdPadTermsComponent,
} from './views';

const routes: Routes = [
  {
    path: '',
    component: TermsComponent,
    pathMatch: 'full',
  },
  {
    path: 'parent',
    component: ParentTermsComponent,
  },
  {
    path: 'organization',
    component: OrganizationTermsComponent,
  },
  {
    path: 'cad-pad',
    component: CadPadTermsComponent,
  },
  {
    path: 'usd-pad',
    component: UsdPadTermsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TermsRoutingModule { }
